import { render, staticRenderFns } from "./LeftSideBar.vue?vue&type=template&id=79cd55da"
import script from "./LeftSideBar.vue?vue&type=script&lang=js"
export * from "./LeftSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports